import { render, staticRenderFns } from "./LongTextAnswer.vue?vue&type=template&id=01fa290c&"
import script from "./LongTextAnswer.vue?vue&type=script&lang=js&"
export * from "./LongTextAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LongTextAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports